import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteInventoryItemApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.HOME_MAINTENANCE.DELETE_INVENTORY_ITEM,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteInventoryItemApi